import { getAddress } from '@ethersproject/address'

// returns the checksummed address if the address is valid, otherwise returns false
export function isAddress(value: any): string | false {
  try {
    return getAddress(value)
  } catch {
    return false
  }
}

export function shortenText(text: string, firstChars = 4, lastChars = 4): string {
  const textLength = text.length
  if (textLength <= firstChars + lastChars) return text
  return `${text.substring(0, firstChars)}...${text.substring(textLength - lastChars)}`
}

// shorten the checksummed version of the input address, default: 0x + 4 characters at start and end
export function shortenAddress(address: string, chars = 4, lastChars = 4): string {
  const parsed = isAddress(address)
  if (!parsed) return address
  return shortenText(parsed, chars + 2, lastChars)
}
